// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Routes_wrapper__3cVOK","messageContainer":"Routes_messageContainer__2ZqF3","message":"Routes_message__2xUnm","logOutbtn":"Routes_logOutbtn__1sTu3"};